export class SelectListItemModel {
    public key: any;
    public value: string;
    public isSelected: boolean;
}
